<div class="user-wrapper" *ngIf="modo !== 'crear' ? grupo : true">
    <div class="user-view-top-area">
        <h1 *ngIf="modo === 'ver' && grupo">{{ grupo.nombre }}</h1>
        <h1 *ngIf="modo === 'editar' && grupo">Editar grupo</h1>
        <h1 *ngIf="modo === 'crear'">Nuevo grupo de empresas</h1>

        <div class="button-area">
            <ng-container *ngIf="modo === 'ver' && grupo">
                <button type="button" class="edit" (click)="activarEdicion()">
                    Editar
                </button>

                <button type="button" class="delete" (click)="eliminarGrupo()">
                    Eliminar
                </button>
            </ng-container>

            <ng-container *ngIf="modo === 'crear' || modo === 'editar'">
                <button type="button" class="delete" (click)="cancelar()">
                    Cancelar
                </button>

                <button type="button" class="edit" (click)="guardar()">
                    Guardar
                </button>
            </ng-container>
        </div>
    </div>

    <div class="user-view-bottom-area">
        <div class="group-box">
            <form [formGroup]="form">
                <div class="block-looper">
                    <div class="form-wrap-wrp">
                        <div class="form-wrap full-field">
                            <mat-label class="label">Nombre</mat-label>

                            <ng-container *ngIf="modo === 'ver'; else editableNombre">
                                <div class="field-value">{{ grupo?.nombre }}</div>
                            </ng-container>

                            <ng-template #editableNombre>
                                <mat-form-field class="field-form full-width" appearance="fill">
                                    <input matInput formControlName="nombre" maxlength="200" />
                                </mat-form-field>

                                <mat-error *ngIf="form.get('nombre')?.hasError('required') && form.get('nombre')?.touched">
                                    El nombre es obligatorio
                                </mat-error>
                            </ng-template>
                        </div>
                    </div>

                    <!-- CREAR GRUPO -->
                    <div class="form-wrap-wrp" *ngIf="modo === 'crear'">
                        <div class="form-wrap full-field">
                            <div class="company-picker">
                                <mat-label class="label">Empresas</mat-label>

                                <div class="tree-box">
                                    <app-tree-view
                                        [origin]="1"
                                        (companyNode)="seleccionarEmpresaCrearDesdeArbol($event)">
                                    </app-tree-view>
                                </div>

                                <div class="company-chips" *ngIf="empresasSeleccionadasCrear.length">
                                    <div class="company-chip" *ngFor="let empresa of empresasSeleccionadasCrear; let i = index">
                                        <span>{{ empresa.nombre }}</span>
                                        <button type="button" (click)="quitarEmpresaSeleccionadaCrear(i)">
                                            <mat-icon>close</mat-icon>
                                        </button>
                                    </div>
                                </div>

                                <mat-error *ngIf="form.get('empresaIds')?.hasError('required') && form.get('empresaIds')?.touched">
                                    Debes seleccionar al menos una empresa
                                </mat-error>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- EMPRESAS EXISTENTES -->
                <div class="companies-section" *ngIf="modo !== 'crear'">
                    <div class="section-header">
                        <h3>Empresas</h3>

                        <button mat-button type="button" class="btn-add-icon" (click)="anadirEmpresa()">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>

                    <!-- PANEL AÑADIR -->
                    <div class="add-company-inline" *ngIf="mostrarPanelAnadirEmpresa">
                        <div class="inline-actions inline-actions-top">
                            <button type="button" class="btn-inline cancel" (click)="cancelarAnadirEmpresa()">
                                Cancelar
                            </button>

                            <button
                                type="button"
                                class="btn-inline save"
                                (click)="guardarNuevaEmpresa()"
                                [disabled]="!(form.get('empresaIdsNuevas')?.value?.length)">
                                Añadir
                            </button>
                        </div>

                        <div class="form-wrap full-field">
                            <mat-label class="label">Empresas</mat-label>

                            <div class="tree-box">
                                <app-tree-view
                                    [origin]="1"
                                    (companyNode)="seleccionarEmpresaAnadirDesdeArbol($event)">
                                </app-tree-view>
                            </div>

                            <div class="company-chips" *ngIf="empresasSeleccionadasAnadir.length">
                                <div class="company-chip" *ngFor="let empresa of empresasSeleccionadasAnadir; let i = index">
                                    <span>{{ empresa.nombre }}</span>
                                    <button type="button" (click)="quitarEmpresaSeleccionadaAnadir(i)">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- LISTADO -->
                    <div class="company-table" *ngIf="grupo?.empresas?.length; else noEmpresasTpl">
                        <table>
                            <tbody>
                                <tr *ngFor="let empresa of grupo.empresas; let i = index">
                                    <td>{{ empresa.nombre }}</td>
                                    <td>
                                        <button
                                            class="btn-iconVert"
                                            mat-button
                                            [matMenuTriggerFor]="menuEmpresa">
                                            <mat-icon>more_vert</mat-icon>
                                        </button>

                                        <mat-menu #menuEmpresa="matMenu" xPosition="before">
                                            <button mat-menu-item (click)="confirmarQuitarEmpresa(empresa, i)">
                                                <mat-icon>delete_outline</mat-icon>
                                                <span>Eliminar</span>
                                            </button>
                                        </mat-menu>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <ng-template #noEmpresasTpl>
                        <div class="empty-block">
                            Este grupo no tiene empresas asociadas.
                        </div>
                    </ng-template>
                </div>
            </form>
        </div>
    </div>
</div>